const baseImageUrlContainer =
  "https://cdn-xpds-onhub-prod-wus2-endpoint.azureedge.net/onhubassetcontainer";

export enum ImageType {
  Jpg = "jpg",
  Png = "png",
}

export const getImage = (fileName: string, imageType: ImageType) =>
  `${baseImageUrlContainer}/${fileName}.${imageType}`;
